import React, { useState } from "react";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

function ResetPasswordToken(props) {
  const navigate = useNavigate();
  // create a new array
  const [otp, setOtp] = useState(new Array(4).fill(""));

  //   function for moving and disble non numbers
  function handleChange(event, i) {
    if (isNaN(event.target.value)) return false;
    setOtp((prev) => [
      ...prev.map((item, index) => (index === i ? event.target.value : item)),
    ]);

    // when  you have one element in one box move to the next box
    if (event.target.value && event.target.nextSibling) {
      event.target.nextSibling.focus();
    }
  }

  localStorage.setItem("OTP", otp);

  return (
    <>
      <Header />
      <section className="reset-password-token">
        <form className="form-container">
          <div className="form-wrapper">
            <div className="form-header">
              <h3>Enter 4 digit number sent to your email</h3>
            </div>
            <div className="form-body">
              <div className="form-field otp-field">
                {otp.map((data, i) => (
                  <input
                    key={i}
                    type="text"
                    onChange={(e) => handleChange(e, i)}
                    value={data}
                    maxLength={1}
                  />
                ))}
              </div>
              {/* <span>{otp.join("")}</span> */}
              {otp.join("").length === 4 ? navigate("/reset-password") : null}
            </div>
          </div>
        </form>
      </section>
    </>
  );
}

export default ResetPasswordToken;
